import React, { memo, useCallback, useEffect, useRef, useState } from 'react';
import clsx from 'clsx';
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip';
import styled from '@emotion/styled';

import './CommonTooltipEllipses.scss';

const CommonTooltipEllipses = ({
  toolTipText,
  label,
  className,
  labelProps,
  cursorOnHover = false,
  maxRows,
  wordWrap = false,
}) => {
  const labelRef = useRef(null);
  const [isEllipsisActive, setIsEllipsisActive] = useState(false);
  const [open, setOpen] = useState(false);

  const handleOpen = useCallback(() => {
    setOpen(true);
  }, []);

  const handleClose = useCallback(() => {
    setOpen(false);
  }, []);

  useEffect(() => {
    if (maxRows) {
      setIsEllipsisActive(labelRef?.current?.offsetHeight < labelRef?.current?.scrollHeight);
      return;
    }

    setIsEllipsisActive(labelRef?.current?.offsetWidth < labelRef?.current?.scrollWidth);
  }, [open, labelRef, setIsEllipsisActive, maxRows]);

  return (
    <StyledTooltip
      placement='top'
      disableInteractive
      arrow
      title={toolTipText}
      open={isEllipsisActive && open}
      onClose={handleClose}
      onOpen={handleOpen}>
      <span
        ref={labelRef}
        className={clsx(
          'common-tooltip-ellipses_text',
          className,
          isEllipsisActive && cursorOnHover && 'common-tooltip-ellipses_text--hovered',
          maxRows && 'common-tooltip-ellipses_text--wrapped',
          wordWrap && 'common-tooltip-ellipses_text--word-wrap',
        )}
        style={{ ...(maxRows ? { lineClamp: maxRows, WebkitLineClamp: maxRows } : {}) }}
        {...(labelProps || {})}>
        {label}
      </span>
    </StyledTooltip>
  );
};

export default memo(CommonTooltipEllipses);

const StyledTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)({
  [`& .${tooltipClasses.tooltip}`]: {
    background: 'var(--table-row-bg-hover)',
    color: 'var(--text-stressed)',
    display: 'flex',
    flexFlow: 'column',
    alignItems: 'center',
    fontFamily: 'Inter',
    fontSize: '12px',
    padding: '8px',
  },
  [`& .${tooltipClasses.tooltip}`]: {
    whiteSpace: 'pre-wrap',
  },
  [`& .${tooltipClasses.arrow}`]: {
    color: 'var(--table-row-bg-hover)',
  },
  [`& .${tooltipClasses.tooltipPlacementTop}`]: {
    bottom: '-4px',
  },
});
